<template lang="pug">
el-dialog.modal-cadastrar-sucursal(
    :title='$t("mensagens.usuarios.editarSucursal")',
    :visible.sync='dialogVisible',
    width='500px',
    :before-close='fecharModal',
    :close-on-click-modal='false'
)
    el-form(:model='sucursale')
        el-form-item
            .label(slot='label')
                span {{ $t('mensagens.usuarios.tabela.nome') }}
                span.erro(v-if='$v.sucursale.nome.$invalid') *
            el-input(
                v-model='sucursale.nome',
                maxlength='100',
                :placeholder='$t("mensagens.comuns.placeholder")'
            )

        el-form-item
            .label(slot='label')
                span CUIT Sucursal
                span.erro(v-if='$v.sucursale.cuit.$invalid') *
            el-input(
                v-model='sucursale.cuit',
                :placeholder='$t("mensagens.comuns.placeholder")',
                maxlength='14',
                @input='formatarCuitInput'
            )

    footer(slot='footer')
        el-button(size='mini', @click='fecharModal') {{ $t('mensagens.comuns.cancelar') }}
        el-button(
            :disabled='$v.sucursale.$invalid',
            size='mini',
            type='primary',
            @click='editarSucursal'
        ) {{ $t('mensagens.comuns.editar') }}
</template>

<script>
import { required, helpers } from 'vuelidate/lib/validators';
import SucursaleService from '@/services/SucursaleService';

const cuitValido = helpers.withParams({ type: 'cuitValido' }, value => {
    if (!value) return false;

    const numeroCuit = value.replace(/\D/g, '');
    if (numeroCuit.length !== 11) return false;

    const multiplicadores = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    let soma = 0;

    for (let i = 0; i < 10; i++) {
        soma += parseInt(numeroCuit[i]) * multiplicadores[i];
    }

    const resto = soma % 11;
    let digitoVerificador;

    if (resto === 0) digitoVerificador = 0;
    else if (resto === 1) digitoVerificador = 9;
    else digitoVerificador = 11 - resto;

    return parseInt(numeroCuit[10]) === digitoVerificador;
});

export default {
    name: 'SucursaleModal',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        sucursal: {
            type: Object
        }
    },
    data() {
        return {
            sucursale: {
                nome: '',
                cuit: ''
            }
        };
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible;
            },
            set(value) {
                this.$emit('update:visible', value);
            }
        }
    },
    watch: {
        visible: {
            handler(novoValor) {
                if (novoValor && this.sucursal) {
                    this.sucursale = {
                        nome: this.sucursal.nome || '',
                        cuit: this.formatarCuit(this.sucursal.documento || '')
                    };
                }
            }
        }
    },
    validations: {
        sucursale: {
            nome: { required },
            cuit: { required, cuitValido }
        }
    },
    methods: {
        formatarCuit(value) {
            const numeros = value.replace(/\D/g, '');

            if (numeros.length <= 2) {
                return numeros;
            } else if (numeros.length <= 10) {
                return `${numeros.slice(0, 2)}-${numeros.slice(2)}`;
            } else if (numeros.length === 11) {
                return `${numeros.slice(0, 2)}-${numeros.slice(
                    2,
                    10
                )}-${numeros.slice(10)}`;
            } else {
                return value;
            }
        },

        formatarCuitInput(value) {
            this.novaSucursal.cuit = this.formatarCuit(value);
        },

        limparFormulario() {
            this.sucursale = {
                nome: '',
                cuit: ''
            };
        },

        fecharModal() {
            this.limparFormulario();
            this.$emit('fechar');
        },

        async editarSucursal() {
            try {
                const cuitSemFormatacao = this.sucursale.cuit.replace(
                    /\D/g,
                    ''
                );

                const dadosSucursal = {
                    nome: this.sucursale.nome,
                    cuit: cuitSemFormatacao
                };

                const { data } = await SucursaleService.editarSucursal(
                    dadosSucursal,
                    this.sucursal.id
                );

                if (data.statusCodeValue === 200) {
                    this.$notify.success({ message: data.body });
                } else {
                    this.$notify.error({ message: data.body });
                }

                this.fecharModal();
                this.$emit('listaSucursais');
            } catch (error) {
                this.$notify.error({
                    message:
                        this.$t('mensagens.sucursales.erroEditar') +
                        `: ${error.response.data.message}`
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-cadastrar-sucursal {
    footer {
        display: flex;
        justify-content: space-between;

        .el-button {
            width: 80px;
        }
    }

    .label {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .erro {
        color: red;
        font-size: 10px;
        display: block;
        line-height: 1.5;
    }

    .el-form-item__label {
        margin-bottom: -10px;
    }
}

.el-select {
    width: 460px;
}
</style>
